import Vue from 'vue'
import Vuex from 'vuex'
import jwt from 'jsonwebtoken'
import { isNull } from 'lodash'
import { differenceInMilliseconds, addMilliseconds } from 'date-fns'
import router from '../router'
import { USER_ID, AUTH_TOKEN } from '../constants/settings'
import { SIGNIN_USER_MUTATION } from '../constants/jwt'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    isAuthenticated: false,
    role: null,
    currentUser: null,
    idToken: null,
    userId: null,
    user: null,
    email: null,
    loginMessage: null
  },
  mutations: {
    authUser (state, userData) {
      state.idToken = userData.token
      state.userId = userData.userId
      state.isAuthenticated = true
      state.role = userData.role
      state.email = userData.email
      state.loginMessage = null
    },
    storeUser (state, user) {
      state.user = user
    },
    loggedOut (state) {
      state.isAuthenticated = false
      state.role = null
      state.email = null
      state.idToken = null
      state.userId = null
    },
    inError (state, errorData) {
      state.loginMessage = errorData.message
    }
  },
  actions: {
    setLogoutTimer ({commit}, expirationTime) {
      console.log('I will expire in', expirationTime, ' ms at',addMilliseconds(new Date(), expirationTime) )
      setTimeout(() => {
        commit('loggedOut')
      }, expirationTime)
    },
    logout ({commit}) {
      commit('loggedOut')
      localStorage.removeItem('expirationDate')
      localStorage.removeItem(AUTH_TOKEN)
      localStorage.removeItem(USER_ID)
      router.replace('/login')
    },
    login ({commit, dispatch}, authData) {
      var email = authData.email.toLowerCase().trim()
      var password = authData.password
      authData.vm.$apollo.mutate({
        mutation: SIGNIN_USER_MUTATION,
        variables: {
          email,
          password
        }
      }).then((result) => {
        if (isNull(result.data.authenticate.jwt)) {
          commit('inError', {message: 'mot de passe ou utilisateur inconnu'})
          return
        }
        const token = result.data.authenticate.jwt
        var decoded = jwt.decode(token, {complete: true})
        const id = decoded.payload.user_id
        const expiresIn = decoded.payload.exp
        const role = decoded.payload.local_role
        const email = decoded.payload.email
        const expirationDate = new Date(expiresIn * 1000)
        const diff = differenceInMilliseconds(new Date(expirationDate), new Date())
        localStorage.setItem(USER_ID, id)
        localStorage.setItem(AUTH_TOKEN, token)
        localStorage.setItem('expirationDate', expirationDate)
        commit('authUser', {
          token: token,
          userId: id,
          role: role,
          email: email
        })
        dispatch('setLogoutTimer', diff)
        authData.vm.$router.push({name: 'Hello'})
      })
        .catch((error) => {
          console.error('signin:', error)
        })
    },
    tryAutoLogin ({commit}) {
      console.log('tryAutologin')
      const token = localStorage.getItem(AUTH_TOKEN)
      if (!token) {
        return
      }
      const expirationDate = localStorage.getItem('expirationDate')
      const now = new Date()
      if (now >= expirationDate) {
        localStorage.removeItem(AUTH_TOKEN) // ?
        return
      }
      const userId = localStorage.getItem(USER_ID)
      var decoded = jwt.decode(token, {complete: true})
      const role = decoded.payload.local_role
      const email = decoded.payload.email
      commit('authUser', {
        token: token,
        userId: userId,
        role: role,
        email: email
      })
      router.push('/')
    }
  },
  computed: {
    isAuthenticated: function () {
      return this.$store.state.isAuthenticated
    }
  },
  getters: {
    isAuthenticatedByToken (state) {
      return state.idToken !== null
    }
  }
})



// WEBPACK FOOTER //
// ./src/state/index.js